import React from "react";
import ReactDOM from "react-dom/client";
import { AddressProvider } from "@spinning-top/koru-nova-frontend-address";
import { DocumentsTicketFileNameProvider } from "@spinning-top/koru-nova-frontend-module-documents";
import { registryDocumentTicketFileName } from "@spinning-top/koru-salus-frontend-base-data-common";
import { App } from "./App.tsx";
import { env } from "./env.ts";
// CSS: index.css imports Tailwind + the design-system tokens, see that file.
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found in index.html");

// Map language/region from the default locale ("it-IT" → "it" / "IT").
const [mapLanguage, mapRegion] = env.VITE_DEFAULT_LOCALE.split("-");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    {/* Address maps configuration for the legal-entities address field. At the app
        root because router-shell does not wire `FEModule.Providers`. Without
        `VITE_GOOGLE_MAPS_API_KEY` it is inert: text fields only, no Google call. It
        never loads the Maps script by itself (only a map/autocomplete in use does). */}
    <AddressProvider
      apiKey={env.VITE_GOOGLE_MAPS_API_KEY}
      language={mapLanguage}
      region={mapRegion}
    >
      {/* The NEUTRAL name «Apri» of a registry's documents puts in the signed URL of a download
          ticket (module-documents 16.3.0): `DOCUMENTO.<ext>`, never the file's own name, which
          would end up in the history. At the root because `<DocumentsSection>` lives in the
          owners' pages, outside the routes `FEModule.Providers` wraps. */}
      <DocumentsTicketFileNameProvider value={registryDocumentTicketFileName}>
        <App />
      </DocumentsTicketFileNameProvider>
    </AddressProvider>
  </React.StrictMode>,
);
